module.exports = __webpack_public_path__ + "static/media/Ancient Indian Temple.a1ad9322.jpeg";